import axios from "axios";
import fetch from "fetch";

class ServiceGetInstanceHTTP {
  getAxios() {
    const axiosInstance = axios.create({
      //timeout: 40000 * 3,
      headers: {
        Authorization: localStorage.getItem("@AsyncStorage:app_archers_token"),
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "localhost:3000",
      },
    });
    return axiosInstance;
  }

  getAxiosToDownload() {
    const axiosInstance = axios.create({
      //timeout: 500000 * 3,
      headers: {
        Authorization: localStorage.getItem("@AsyncStorage:app_archers_token"),
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "localhost:3000",
      },
      responseType: "blob",
    });
    return axiosInstance;
  }

  getFetch(url) {
    return fetch(url, {
      headers: {
        Authorization: localStorage.getItem("@AsyncStorage:app_archers_token"),
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "localhost:3000",
      },
    });
  }
}
export default new ServiceGetInstanceHTTP();
